function sliderTextMedia() {
    const swiperContainer = document.querySelector('.text_media_swiper-js');

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: ".text_media_swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".text_media_swiper-button-next",
            prevEl: ".text_media_swiper-button-prev",
        },
    });
}

$(function() {
    sliderTextMedia();
});